'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _min2 = require('lodash/min');

var _min3 = _interopRequireDefault(_min2);

var _class, _class2, _temp;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _ramda = require('ramda');

var _background = require('../background');

var _background2 = _interopRequireDefault(_background);

var _utils = require('../utils/');

var utils = _interopRequireWildcard(_utils);

var _selectors = require('./selectors');

var _selectors2 = _interopRequireDefault(_selectors);

var _accessors = require('./accessors');

var _accessors2 = _interopRequireDefault(_accessors);

var _computors = require('./computors');

var _computors2 = _interopRequireDefault(_computors);

var _eauors = require('./eauors');

var _eauors2 = _interopRequireDefault(_eauors);

var _getAxisOptions = require('../utils/getAxisOptions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerticalSymbolChart = (0, _selectors2.default)(_class = (0, _computors2.default)(_class = (0, _accessors2.default)(_class = (0, _eauors2.default)(_class = (_temp = _class2 = function (_BackgroundChart) {
  (0, _inherits3.default)(VerticalSymbolChart, _BackgroundChart);

  function VerticalSymbolChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var getInitialOptions = arguments[3];
    var getAxisOptions = arguments[4];
    (0, _classCallCheck3.default)(this, VerticalSymbolChart);

    var datapoints = VerticalSymbolChart.computors.data(data);
    //maybe not ideal, but since override of computors.data from BaseChart doesn't work ...

    var _this = (0, _possibleConstructorReturn3.default)(this, (VerticalSymbolChart.__proto__ || (0, _getPrototypeOf2.default)(VerticalSymbolChart)).call(this, el, options, [{ datapoints: datapoints }], getInitialOptions));

    _contructor(el, _this.options, data, {
      selectors: _this.constructor.selectors,
      accessors: _this.constructor.accessors,
      computors: _this.constructor.computors,
      eauors: _this.constructor.eauors
    }, _this.base, _this.axis);
    return _this;
  }

  (0, _createClass3.default)(VerticalSymbolChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var getInitialOptions = arguments[3];
      var getAxisOptions = arguments[4];

      var datapoints = VerticalSymbolChart.computors.data(data);
      (0, _get3.default)(VerticalSymbolChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(VerticalSymbolChart.prototype), 'update', this).call(this, el, options, [{ datapoints: datapoints }], getInitialOptions);
      _update(el, this.options, data, {
        selectors: this.constructor.selectors,
        accessors: this.constructor.accessors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors
      }, this.base, this.axis, getAxisOptions);
    }
  }]);
  return VerticalSymbolChart;
}(_background2.default), _class2.ors = ['selectors', 'accessors', 'computors', 'eauors'], _temp)) || _class) || _class) || _class) || _class;

exports.default = VerticalSymbolChart;


function _contructor(el, options, data, ors, base, axis) {

  utils.noElError(el);

  _d2.default.select(el).select(utils.selector(ors.selectors.base)).call(utils.setupElement, 'svg:g', ors.selectors.serie);

  _update(el, options, data, ors, base, axis);
}

function _update(el, options, data, ors, base, axis, getAxisOptions) {
  if (process.env.NODE_ENV !== 'production') {
    console.time(utils.prefix + ' VerticalSymbolChart#_update');
  }

  utils.noElError(el);
  if (utils.noDataError(ors.accessors.data(data), '\t\t\t\t', 'VerticalSymbolChart')) {
    _d2.default.select(el).selectAll(utils.selector(ors.selectors.symb)).remove();
    return;
  }

  var scales = {
    xScale: ors.accessors.xScale(base, axis),
    yScale: ors.accessors.yScale(base, axis)
  };

  var symbolValues = ors.accessors.symbolValues(data);
  //dimension value name matching the symbol, for the tooltip ...

  var symbJoin = _d2.default.select(el).select(utils.selector(ors.selectors.serie)).selectAll(utils.selector(ors.selectors.symb)).data(ors.accessors.data(data)); //bound to the ordinal series of datapoints
  symbJoin.enter().call(ors.eauors.symbEnter, options.serie, ors.selectors.symb);
  symbJoin.exit().remove();

  var axisCoord = (0, _min3.default)(scales.yScale.domain());
  //needed for the following lines,
  //get the coordinate of the ordinalAxis from the linear,
  //the x of yAxis in horizontal, the y of xAxis in vertical,
  //->min value of linear scale domain

  var gapAxisMinJoin = symbJoin //line gap between ordinal axis and min values
  .selectAll(utils.selector(ors.selectors.gapAxisMin)).data(function (data) {
    return [data];
  });
  gapAxisMinJoin.enter().call(ors.eauors.gapAxisMinEnter, ors.selectors);
  gapAxisMinJoin.call(ors.eauors.gapAxisMinUpdate, options, ors.accessors, scales, axisCoord);
  gapAxisMinJoin.exit().remove();

  var gapMinMaxJoin = symbJoin //line gap between min and max values
  .selectAll(utils.selector(ors.selectors.gapMinMaxLine)).data(function (data) {
    return [data];
  });
  gapMinMaxJoin.enter().call(ors.eauors.gapMinMaxEnter, ors.selectors);
  gapMinMaxJoin.call(ors.eauors.gapMinMaxUpdate, options, ors.accessors, scales);
  gapMinMaxJoin.exit().remove();

  // these two gaps Join annoys me a little => two data join identical
  //didn't find a way to build the two lines inside an unique dataJoin;

  var markerJoin = symbJoin.selectAll(utils.selector(ors.selectors.marker)).data(ors.computors.computeMarkers(symbolValues));
  markerJoin.enter().call(ors.eauors.markerEnter, options, ors.selectors, ors.accessors, symbJoin, base.hideTooltip);
  markerJoin.call(ors.eauors.markerUpdate, options, ors.accessors, scales, base.showTooltip);
  markerJoin.exit().remove();

  var xAxisLabelJoin = _d2.default.select(el).select(utils.selector(ors.selectors.xAxis)).selectAll('text').data(ors.computors.computeOrdinalFocus(data));
  xAxisLabelJoin.call(ors.eauors.xAxisLabelUpdate, options.serie, ors.accessors);

  if ((0, _ramda.is)(Function, getAxisOptions)) {
    var yAxisoptions = (0, _getAxisOptions.getLinearAxisOptions)(axis.yAxis, options.axis.y);
    getAxisOptions({
      computedMinY: yAxisoptions.min,
      computedMaxY: yAxisoptions.max,
      computedStepY: yAxisoptions.step,
      computedPivotY: yAxisoptions.pivot
    });
  }
  if (process.env.NODE_ENV !== 'production') {
    console.timeEnd(utils.prefix + ' VerticalSymbolChart#_update');
  }
}